import React from "react";
import { string, objectOf, shape, arrayOf, number, oneOfType } from "prop-types";
import classNames from "classnames/bind";
// eslint-disable-next-line import/no-cycle
import { Link } from "../../sharedComponents/Link";
import { CommentIcon } from "./CommentIcon";
import * as styles from "./QuickLInksSupport.module.scss";

const cx = classNames.bind(styles);

const QuickLink = ({ url, target, linkText }) => (
	<li className={cx(styles.link)}>
		<Link to={url} target={target}>
			{linkText}
		</Link>
	</li>
);

const QuickLinksSupport = ({ style, className, title, links, moreInfoLink }) => (
	<div className={cx("contentWrapper", className)} style={style}>
		<div className={cx("heading")}>
			<CommentIcon />
			<span className={cx("title")}>{title}</span>
		</div>
		<div className={cx("body")}>
			<ul>
				{links.map(l => (
					<QuickLink url={l.url} target={l.target} linkText={l.linkText} key={l.id} />
				))}
			</ul>
		</div>
		<div className={cx("footer")}>
			<Link to={moreInfoLink.url} target={moreInfoLink.target}>
				{moreInfoLink.linkText}
			</Link>
		</div>
	</div>
);
QuickLink.propTypes = {
	url: string.isRequired,
	target: string,
	linkText: string,
};
QuickLink.defaultProps = {
	linkText: "",
	target: "_self",
};
QuickLinksSupport.propTypes = {
	title: string.isRequired,
	links: arrayOf(
		shape({
			urlLink: string.isRequired,
			target: string,
			linkText: string,
			id: string,
		})
	),
	moreInfoLink: shape({
		urlLink: string.isRequired,
		target: string,
		linkText: string,
		id: string,
	}),
	className: string,
	style: objectOf(oneOfType([string, number])),
};
QuickLinksSupport.defaultProps = {
	links: [],
	moreInfoLink: {},
	className: "",
	style: {},
};

export default QuickLinksSupport;
export { QuickLinksSupport };
